import * as React from 'react';
import { ShopClient } from './spacex';

export const ClientContext = React.createContext<ShopClient>(undefined as any);

export function useClient() {
    return React.useContext(ClientContext);
}